export default function (router) {
  router.beforeEach((to, from, next) => {
    if (to.name !== 'Login' && !localStorage.user) {
      router.replace({ name: 'Login' })
    }
    next()
  })
}
